varying vec2 vUv;
varying vec3 vWorldPosition;
varying vec3 vNormal;


uniform sampler2D uPerlin;
uniform float uTime;
uniform vec3 uColorOne;
uniform vec3 uColorTwo;
uniform float uLightIntensity;

void main() {
  vec2 globalUv = vWorldPosition.xz * 0.1; 

  float noice = texture2D(uPerlin, globalUv * 0.1).r;
  
  vec3 colorOne = uColorOne * vUv.y;
  vec3 colorTwo = uColorTwo;

  vec3 color = mix(colorOne, colorTwo, noice) * uLightIntensity;


  gl_FragColor = vec4(color, 1.0);

}